module.exports = __webpack_public_path__ + "img/huizongchuli.1b232e92.png";